import * as React from 'react';

import Icon from 'react-fa';
import StarRatingComponent from 'react-star-rating-component';
const BanStyle = {
  color: 'rgba(169, 169, 169, 0.5)',
  paddingRight: '0.25em',
}
const RenderStarIcon = (index, value, name) =>
  index === 1
    ? <Icon name='ban' style={BanStyle} />
    : (value >= index
      ? <Icon name='star' />
      : <Icon name='star-o' />)
const Stars = ({ name, value, editing, onChange }) => (
  <StarRatingComponent
    name={name}
    value={value}
    starCount={editing ? 6 : 5}
    starColor="blue"
    emptyStarColor="darkgrey"
    editing={editing}
    onStarClick={onChange}
    renderStarIcon={RenderStarIcon} />
);

/* <Stars name={`${aspect.id}.rating`} value={review.rating} editing={selected} /> */

const renderStars = ({ input, stars, value, label, name, meta: { touched, error } }) => (
  <Stars onChange={(value) => input.onChange(value-1)} value={input.value + 1} name={input.name} {...stars} />
);

export default renderStars;



// WEBPACK FOOTER //
// ./src/app/components/fields/Stars.tsx